@if (user$ | async; as user) {
  <div class="hidden xs:flex">
    <button class="!h-16" mat-button [matMenuTriggerFor]="companyMenu">
      <div class="avatar-button">
        <avatar
          class="mr-2 flex items-center w-12 h-12"
          [picture]="primaryCompany?.logo"
          [url]="primaryCompany | getCompanyUrl"
          fallbackImage="unknow-company"
          [sizes]="[{w: 48, h:48, resizeMode: 'avatar'}]">
        </avatar>
        <span class="username hidden 2xl:inline" i18n>My Company</span>
        <div class="hidden xl:flex">
          <mat-icon svgIcon="core:keyboard_arrow_down"></mat-icon>
        </div>
      </div>
    </button>
  </div>
  <div class="hidden xs:flex">
    <button class="!h-16" mat-button [matMenuTriggerFor]="userMenu">
      <div class="avatar-button">
        <avatar
          class="mr-2 flex items-center w-12 h-12"
          [picture]="user.profile.picture"
          [url]="user | getUserUrl"
          fallbackImage="unknow-user"
          [sizes]="[{w: 48, h:48, resizeMode: 'avatar'}]">
        </avatar>
        <span class="username hidden 2xl:inline">My Expometals</span>
        <div class="hidden xl:flex">
          <mat-icon svgIcon="core:keyboard_arrow_down"></mat-icon>
        </div>
      </div>
    </button>
  </div>
  <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item [routerLink]="user | getUserUrl">
      <mat-icon svgIcon="core:account_circle"></mat-icon>
      <span i18n>Profile</span>
    </button>
    <!-- <button mat-menu-item routerLink="/orders-board">
    <mat-icon svgIcon="user:compare_arrows"></mat-icon>
    <span i18n>Negotiations</span>
  </button> -->
  <!-- <button mat-menu-item>
  <mat-icon svgIcon="user:import_contacts"></mat-icon>
  <span i18n>Address Book</span>
</button> -->
<button mat-menu-item [routerLink]="(user | getUserUrl) + '/edit/'+ selectedLanguage.code">
  <mat-icon svgIcon="user:settings_applications"></mat-icon>
  <span i18n>Edit profile</span>
</button>
<hr class="my-1">
<button mat-menu-item class="" [routerLink]="(user | getUserUrl) + '/followed-companies'">
  <mat-icon svgIcon="core:account_circle"></mat-icon>
  <span i18n>Followed companies</span>
</button>
<button mat-menu-item class="" [routerLink]="(user | getUserUrl) + '/saved-products'">
  <mat-icon svgIcon="core:bookmark"></mat-icon>
  <span i18n>Saved products</span>
</button>
<button mat-menu-item class="" [routerLink]="(user | getUserUrl) + '/saved-news'">
  <mat-icon svgIcon="newsletter:speaker_notes"></mat-icon>
  <span i18n>Saved news</span>
</button>
<hr class="my-1">
<button mat-menu-item class="" (click)="logout()">
  <mat-icon svgIcon="user:exit_to_app"></mat-icon>
  <span i18n>Log out</span>
</button>
</mat-menu>
<mat-menu #companyMenu="matMenu" [overlapTrigger]="false">
  @if (primaryCompany) {
    <button mat-menu-item [routerLink]="primaryCompany | getCompanyUrl">
      <mat-icon svgIcon="user:web"></mat-icon>
      <span i18n>Online Stand</span>
    </button>
  <button mat-menu-item [routerLink]="(primaryCompany | getCompanyUrl) + '/edit/info/' + selectedLanguage.code + '/' + primaryCompany._id">
    <mat-icon svgIcon="user:settings_applications"></mat-icon>
    <span i18n>Settings</span>
  </button>
  <hr class="my-1">
    <!-- <button mat-menu-item routerLink="/orders-board">
    <mat-icon svgIcon="user:compare_arrows"></mat-icon>
    <span i18n>Negotiations</span>
  </button> -->
  @if (primaryCompany.reportLink) {
    <button mat-menu-item [routerLink]="[(primaryCompany | getCompanyUrl) + '/edit/stand-stats/' + primaryCompany._id]">
      <mat-icon svgIcon="stand:insights_black"></mat-icon>
      <span i18n>Report</span>
    </button>
  }
  @if(!isCustomer()){
    <a mat-menu-item href="/join-now" target="_blank">
      <mat-icon svgIcon="stand:insights_black"></mat-icon>
      <span i18n>Report</span>
    </a>
  }
  @if (primaryCompany.hasLeads) {
    <button mat-menu-item *ngIf="primaryCompany.hasLeads" [routerLink]="(primaryCompany | getCompanyUrl) + '/edit/leads/' + primaryCompany._id">
      <mat-icon svgIcon="core:account_circle"></mat-icon>
      <span i18n>Leads</span>
    </button>
  }
  @if(!isCustomer()){
    <a mat-menu-item href="/join-now" target="_blank">
      <mat-icon svgIcon="core:account_circle"></mat-icon>
      <span i18n>Leads</span>
    </a>
  }
<!-- <button mat-menu-item [routerLink]="(primaryCompany | getCompanyUrl) + '/edit/requests/' + primaryCompany._id">
  <mat-icon svgIcon="core:email"></mat-icon>
  <span i18n>Requests</span>
</button> -->
  <hr class="my-1">
  @if(isCustomer()){
    <a class="mt-2" mat-menu-item href="https://res.cloudinary.com/expometals/image/upload/v1731591061/expometals/docs/price-list-oct2024.pdf" target="_blank">
      <mat-icon svgIcon="stand:attach_money"></mat-icon>
      <span i18n>Upgrade</span>
    </a>
  }
  @else{
    <a class="mt-2" mat-menu-item href="/join-now" target="_blank">
      <mat-icon svgIcon="stand:attach_money"></mat-icon>
      <span i18n>Upgrade</span>
    </a>
  }
<!--       <button mat-menu-item [routerLink]="(primaryCompany | getCompanyUrl) + '/edit/embedded-widget/' + primaryCompany._id">
<mat-icon svgIcon="user:widgets"></mat-icon>
<span i18n>Widget</span>
</button> -->
<!-- <button mat-menu-item *ngIf="hasRequests" [routerLink]="(primaryCompany | getCompanyUrl) + '/edit/stand-requests/' + primaryCompany._id">
<mat-icon svgIcon="user:mail"></mat-icon>
<span i18n>Requests</span>
</button> -->
<!-- <button mat-menu-item>
<mat-icon svgIcon="user:signal_cellular_4_bar"></mat-icon>
<span i18n>Statistics</span>
</button> -->
<!-- <button mat-menu-item>
<mat-icon svgIcon="user:filter_9_plus"></mat-icon>
<span i18n>Banners</span>
</button> -->
<!-- <button mat-menu-item>
<mat-icon svgIcon="core:email"></mat-icon>
<span i18n>DEM</span>
</button> -->
<!-- <button mat-menu-item>
<mat-icon svgIcon="user:translate"></mat-icon>
<span i18n>Translations</span>
</button> -->
<!-- <button mat-menu-item>
<mat-icon svgIcon="user:youtube_searched_for"></mat-icon>
<span i18n>SEO</span>
</button> -->
} @else {
  <button mat-button (click)="addNewCompany()">
    <mat-icon svgIcon="core:add"></mat-icon>
    <span i18n>Add your company</span>
  </button>
}
</mat-menu>
}
